import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  ErrorText,
  FieldWrapper,
  GenericFormFieldHintText,
  GenericFormFieldLabelRow,
  GenericFormFieldLabelText,
  GenericFormPhoneInputRoot,
} from "styles/formStyleComponents";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

const PhoneFieldComponent = ({
  name,
  label,
  placeholder,
  value,
  required,
  disabled,
  error,
  info,
  field = {},
  onChange,
  onFieldBlur,
  compact = false,
}) => {
  const country = field.country ?? "us";
  const tooltipInfo = info || field.info;
  const hintBelow = field.showHintBelow === true ? field.hint : null;
  const inputPlaceholder = placeholder || (compact ? undefined : label);

  const handleBlur = (_event, phoneValue) => {
    const currentValue =
      phoneValue !== undefined && phoneValue !== null ? phoneValue : value;
    if (onFieldBlur) {
      onFieldBlur(name, currentValue);
    }
    if (typeof field.onBlur === "function") {
      field.onBlur(currentValue);
    }
  };

  return (
    <FieldWrapper>
      {label && !compact ? (
        <GenericFormFieldLabelRow>
          <GenericFormFieldLabelText variant="body2">
            {label}
            {required ? " *" : ""}
          </GenericFormFieldLabelText>
          <InfoIconWithTooltip info={tooltipInfo} />
        </GenericFormFieldLabelRow>
      ) : null}
      <GenericFormPhoneInputRoot hasError={!!error}>
        <PhoneInput
          country={country}
          value={value || ""}
          placeholder={inputPlaceholder}
          onChange={(phoneValue) => onChange(name, phoneValue)}
          inputProps={{
            name,
            required,
            autoComplete: "tel",
            "aria-label": compact ? label : undefined,
            onBlur: (e) => handleBlur(e, e?.target?.value ?? value),
          }}
          disabled={disabled}
        />
      </GenericFormPhoneInputRoot>
      {hintBelow && (
        <GenericFormFieldHintText variant="caption">{hintBelow}</GenericFormFieldHintText>
      )}
      {error ? <ErrorText error>{error}</ErrorText> : null}
    </FieldWrapper>
  );
};

export default PhoneFieldComponent;
